// dev-shein.vendia.com.co (Nginx, estático) contra dev-api-shein.vendia.com.co (Nginx → 3006).
// ogBaseUrl = mismo dominio del front: Nginx envía /og/ al backend del entorno (SPEC RN-TIE-50).
export const environment = {
  production: false,
  apiUrl: 'https://dev-api-shein.vendia.com.co/api/v1',
  socketUrl: 'https://dev-api-shein.vendia.com.co',
  publicBaseUrl: 'https://dev-shein.vendia.com.co',
  ogBaseUrl: 'https://dev-shein.vendia.com.co',
  captchaSiteKey: '0x4AAAAAAFFwi56KZchNEyHE',
};
